import Routes from 'routes';
import ThemeCustomization from 'themes';
import Locales from 'components/Locales';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import useHandleCache from 'hooks/useHandleCache'; // Custom hook for handling cache version
import React, { useEffect, useState } from 'react';
import { Modal, Button, Card } from '@mui/material';
// import packageJson from '../package.json'; // Import the app version for comparison
// import { checkVersionMismatch } from 'utils/commonFunctions';
import PrivateKeyProvider from 'contexts/PrivateKeyContext';

const App = () => {
  // const { isLoading, isLatestVersionAvailable } = useHandleCache(); // Hook to check version mismatch
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // Polling logic to frequently check `meta.json`
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetch('/meta.json', { cache: 'no-store' })
  //       .then((response) => response.json())
  //       .then((meta) => {
  //         const latestVersion = meta.version;
  //         const currentVersion = packageJson.version;
        
  //         console.log("latestVersion",latestVersion);
  //         console.log("currentVersion",currentVersion);
          
  //         if (checkVersionMismatch(latestVersion, currentVersion)) {
  //           setShowUpdateModal(true); // Show the modal if a mismatch is detected
  //         }
  //       })
  //       .catch((error) => console.error('Error fetching meta.json:', error));
  //   }, 600000); // Poll every 600000 ms

  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);

  // useEffect(() => {
  //   // Show the update modal if a new version is detected
  //   if (!isLatestVersionAvailable) {
  //     setShowUpdateModal(true);
  //   }
  // }, [isLatestVersionAvailable]);

  useEffect(() => {
    // Listen for service worker messages
    console.log('NEW_VERSION check');
    
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'NEW_VERSION') {
          setShowUpdateModal(true);
        }
      });
    }
  }, []);

  const handleRefresh = () => {
    setShowUpdateModal(false);
    window.location.reload(true); // Force reload to get the new version
  };

  // if (isLoading) {
  //   return <div>Loading...</div>; // Show a loading spinner or placeholder while checking the version
  // }

  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <>
              <PrivateKeyProvider>
                <Notistack>
                  <Routes />
                  <Snackbar />
                </Notistack>
              </PrivateKeyProvider>
            </>
          </AuthProvider>
        </ScrollTop>
      </Locales>

      {/* Update Modal */}
      {showUpdateModal && (
        <Modal open={true} onClose={() => setShowUpdateModal(false)}>
          <Card
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: 24,
              outline: 'none',
              textAlign: 'center',
            }}
          >
            <h2>Update Available</h2>
            <p>A new version of the app is available. Please refresh to update.</p>
            <Button variant="contained" color="primary" onClick={handleRefresh}>
              Refresh
            </Button>
          </Card>
        </Modal>
      )}
    </ThemeCustomization>
  );
};

export default App;
